<template>
    <div id="service-staff-setting" class="shadow-md rounded-item">
        <vx-card>
            <div class="setting-card-hidden">
                <div class="setting-card-scroll">
                    <!-- <div class="flex align-center justify-between"> -->
                        <h4 class="text-2xl font-bold mb-6">QR Code Setting</h4>
                        <vs-button @click="releaseQRCode">Release QR Code</vs-button>
                    <!-- </div> -->
                    <!-- <div class="flex align-center">
                        <vs-switch v-model="qrCode" class="my-6" @click.stop="updateQRCodeSetting"/>
                        <span class="pl-5">Active QR Code</span>
                    </div>
                    <vs-button @click="downloadQRCode" v-if="download_link && !isNaN(clientId)">Download QR Code</vs-button> -->
                </div>
            </div>
        </vx-card>
    </div>
</template>
<script>
import axios from 'axios'

export default {
    name: 'qr-code-setting',
    data() {
        return {
            qrCode: false,
            loaded_data_num: 0,
            isOpenLoading: false,
            action_type: '',
            download_link: '',
            clientId: localStorage.getItem("domainId")
        }
    },
    watch: {
        loaded_data_num: {
            immediate: true,
            handler() {
                if(this.loaded_data_num >= 1) {
                    this.closeLoading();
                } else {
                    this.action_type = "Get Data";
                    this.openLoadingInDiv();
                }
            }
        }
    },
    methods: {
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if (this.loadTime) {
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                this.closeLoading();
                this.$vs.dialog({
                    color: 'danger',
                    title: 'Notification',
                    text: this.action_type + ' QR Code Setting Failed',
                    acceptText: 'OK'
                })
                }
            }, 10000);
        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        updateQRCodeSetting() {
            const obj = {
                key: 'config.pos.qrCode_active',
                value: !this.qrCode ? 1 : 0
            }
            this.action_type = 'Update';
            this.openLoadingInDiv();
            this.$store.dispatch("appSetting/UPDATE_KEY_STORAGE", obj).then(() => {
                this.closeLoading();
                this.$vs.notify({
                title:'Notification',
                text:'Update QR Code Setting Success',
                color:'success',
                position:'top-right'})
            });
        },
        getDownloadLink() {
            let apiUrl = `https://dev.business.gocheckin.net/api/rest/company/get_order_qr_codes_download_link?whmcs_id=${this.clientId}`;
            delete axios.defaults.headers.common['Authorization'];
            axios({
                method: "GET",
                url: apiUrl,
                headers: {
                    'Content-Type': 'application/json',
                }
            }).then((res) => {
                this.download_link = res.data && res.data.company_get_order_qr_codes_zip_file_download_link ? res.data.company_get_order_qr_codes_zip_file_download_link : '';
            })
        },
        downloadQRCode() {
            if(this.download_link) {
                window.open(this.download_link);
            }
        },
        releaseQRCode() {
            this.action_type = 'Release';
            this.openLoadingInDiv();
            this.$store.dispatch("appSetting/RELEASE_QR_CODE", {}).then(() => {
                this.closeLoading();
                this.$vs.notify({
                    title:'Notification',
                    text:'Release QR Code Success',
                    color:'success',
                    position:'top-right'})
            }).catch((err) => {
                this.closeLoading();
                this.$vs.notify({
                    title:'Notification',
                    text:'Release QR Code Failed',
                    color:'danger',
                    position:'top-right'})
            })
        }
    },
    created() {
        if(!isNaN(this.clientId)) {
            this.getDownloadLink();
        }
        const obj = {
            key: 'config.pos.qrCode_active'
        }

        this.$store.dispatch("appSetting/GET_KEY_STORAGE" ,obj).then(() => {
            this.loaded_data_num++;
            let qrCode = this.$store.getters["appSetting/keyStorage"];
            this.qrCode = qrCode.value == 1 ? true : false;
        }).catch(() => {
            const obj = { 
                key: 'config.pos.qrCode_active',
                value: 0
            }
            this.$store.dispatch("appSetting/ADD_KEY_STORAGE", obj).then(() => {
                this.loaded_data_num++;
            })
        })
    }
}
</script>

